const TARGET_PATH = "targetPath";

export const saveTargetPath = (path) => {
  saveToSessionStorage(TARGET_PATH, path);
};

export const getTargetPath = () => getFromSessionStorage(TARGET_PATH) || "/";

export const saveToSessionStorage = (k, v) => {
  window.sessionStorage.setItem(k, v);
};

export const clearSessionStorage = (k) => {
  window.sessionStorage.removeItem(k);
};

export const getFromSessionStorage = (k) => window.sessionStorage.getItem(k);

// LocalStorage methods for persistent login
export const saveToLocalStorage = (k, v) => {
  window.localStorage.setItem(k, v);
};

export const clearLocalStorage = (k) => {
  window.localStorage.removeItem(k);
};

export const getFromLocalStorage = (k) => window.localStorage.getItem(k);

export const isLoggedIn = () => {
  const sessionLogin = getFromSessionStorage("isLoggedIn");
  const localLogin = getFromLocalStorage("isLoggedIn");
  return sessionLogin === "true" || localLogin === "true";
};

export const getAccessToken = () => {
  return getFromSessionStorage("access_token") || getFromLocalStorage("access_token") || "";
};

export const getIdToken = () => {
  return getFromSessionStorage("id_token") || getFromLocalStorage("id_token") || "";
};

export const getExpireBy = () => {
  return getFromSessionStorage("expire_by") || getFromLocalStorage("expire_by") || 0;
};

export const getPermissions = () => {
  return getFromSessionStorage("permissions") || getFromLocalStorage("permissions") || "";
};

export const getEmail = () => {
  return getFromSessionStorage("userEmail") || getFromLocalStorage("userEmail") || "";
};

export const getUsername = () => {
  return getFromSessionStorage("userName") || getFromLocalStorage("userName") || "";
};

export const setUserName = (name) => {
  saveToSessionStorage("userName", name);
};

export const setIsReferralUsers = (isReferralUsers) => {
  saveToSessionStorage("isReferralUsers", isReferralUsers);
};

export const setUserRefId = (UserRefId) => {
  saveToSessionStorage("userRefId", UserRefId);
};

export const setLoggedIn = (flag) => {
  saveToSessionStorage("isLoggedIn", flag);
  // Also save to localStorage for persistence across browser sessions
  saveToLocalStorage("isLoggedIn", flag);
};

export const setUserEmail = (flag) => {
  saveToSessionStorage("userEmail", flag);
  saveToLocalStorage("userEmail", flag);
};

export const setAccessToken = (access_token) => {
  saveToSessionStorage("access_token", access_token);
  saveToLocalStorage("access_token", access_token);
};

export const setIdToken = (id_token) => {
  saveToSessionStorage("id_token", id_token);
  saveToLocalStorage("id_token", id_token);
};

export const setExpireBy = (expire_by) => {
  saveToSessionStorage("expire_by", expire_by);
  saveToLocalStorage("expire_by", expire_by);
};

export const setPermissions = (permissions) => {
  saveToSessionStorage("permissions", permissions);
  saveToLocalStorage("permissions", permissions);
};

export const clearSession = () => {
  // Clear from both sessionStorage and localStorage
  clearSessionStorage("isLoggedIn");
  clearSessionStorage("access_token");
  clearSessionStorage("id_token");
  clearSessionStorage("expire_by");
  clearSessionStorage("permissions");
  clearSessionStorage("userEmail");
  
  clearLocalStorage("isLoggedIn");
  clearLocalStorage("access_token");
  clearLocalStorage("id_token");
  clearLocalStorage("expire_by");
  clearLocalStorage("permissions");
  clearLocalStorage("userEmail");
};
